import styles from "./app.module.css"
import AppMainAnn from "../app-main-ann/app-main-ann"

import { useEffect, useRef } from "react"
import { Route, Routes, useLocation } from "react-router-dom"
import NotFound from "../app-error-pages/not-found/not-found"
import LayoutMain from "../layout-main/layout-main"
import AppMain from "../app-main/app-main"
import Authorization from "../app-authorization/app-authorization-page"
import AboutCard from "../pages/about-card/about-card"
import { useDispatch } from "react-redux"
// import {
//   responseStatus,
//   getCardsMainNew,
//   getCardsMainAnalytics,
// } from "../../utils/api"
// import { setObject } from "../../services/reducers/cards-slice"
import Education from "../pages/education/education"
import LessonsPage from "../pages/lessons-page/lessons-page"
import Lesson from "../pages/lesson/lesson"
import Tables from "../pages/tables/tablesColumn"
import Table from "../pages/table/table"
import PageInfo from "../pages/page-info/page-info"
import Profile from "../app-main-profile/app-main-profile"
import { ActiveButtonProvider } from "../../services/context/ActiveButtonContext"
import { ActiveCountryTagProvider } from "../../services/context/CountryFilterContext"
import { ActiveFiltersProvider } from "../../services/context/ActiveFiltersContext"
import { ProfileProvider } from "../../services/context/ProfileContext"
import { PageInfoProvider } from "../../services/context/PageInfoContext"
import PageInfoUrl from "../../components/pages/page-info/page-info-url/page-url-info"
import ProductSub from "../../components/pages/products/product-sub-url/product-sub-url"
import NoAccess from "../no-access-page/no-access-page"
import Error500 from "../app-error-pages/error-500/error-500"
import Error403 from "../app-error-pages//error-403/error-403"
import { WebinarProvider } from "../../services/context/WebinarContext"
import Webinars from "../pages/webinars/webinars"
import {isClickEnter, isUserDelete} from "../../services/reducers/modal-slice";
import AboutUs from "../about-us/about-us"
import { MainPageProvider } from "../../services/context/MainPageContext"
import { HelmetProvider } from "react-helmet-async"
import TableNew from "../pages/table-new/table-new"
import { EducationProvider } from "../../services/context/EducationContext"

function App() {
  const dispatch = useDispatch()
  const location = useLocation()

  // const getData = () => {
  //   return fetch(`api/analytics-and-news/`)
  //     .then(responseStatus)
  //     .then((res) => {
  //       dispatch(setObject(res.results))
  //     })
  // }

  // useEffect(() => {
  //   getData()
  //   dispatch(getCardsMainNew())
  //   dispatch(getCardsMainAnalytics())
  // }, [])
// console.log(parseInt(localStorage.getItem("_ym_uid").slice(1, -1)));
    
  const mounted = useRef()

  useEffect(() => {
    if (!!window.ym) {
      window.ym(96742836, "hit", location.pathname)
    }
  },[location.pathname]);


  useEffect(() => {
    if (location.pathname !== "/authorization") {
      dispatch(isUserDelete(false))
      dispatch(isClickEnter(false))
    }
    if ( localStorage.getItem("token") && location.pathname !== "/authorization" && location.pathname !== "/profile") {
      localStorage.setItem("location", location.pathname)
    }
  },[location.pathname]);

  return (
    <HelmetProvider>
    <ActiveCountryTagProvider className={styles.app}>
      <Routes>
      <Route path="/" element={<LayoutMain />}>
      <Route path="/authorization" element={<Authorization />} />

      <Route element={<MainPageProvider />}>
          <Route index element={<AppMain />} />
      </Route>

            <Route path="/noaccess" element={<NoAccess />} />
            <Route path="/error-500" element={<Error500 />} />
            <Route path="/error-403" element={<Error403 />} />
            <Route path="*" element={<NotFound />} />

            <Route element={<WebinarProvider />}>
              <Route path="/webinars" element={<Webinars />} />
            </Route>

            <Route element={<ActiveFiltersProvider />}>
              <Route path="/analytics-and-news/" element={<AppMainAnn />} />
              <Route path="/analytics-and-news/:slug" element={<AboutCard />} />
            </Route>

            <Route element={<EducationProvider />}>
              <Route path="/education" element={<Education />} />
              <Route path="/education/:slug" element={<LessonsPage />} />
              <Route path="/lessons/:slug" element={<Lesson />} />
            </Route>


            <Route path="/about-us" element={<AboutUs />} />

            <Route element={<ProfileProvider />}>
              <Route path="/profile" element={<Profile />} />

              <Route path="/products/:slug" element={<ProductSub />} />
            </Route>

            <Route element={<ActiveButtonProvider />}>
              <Route path="/tables" element={<Tables />} />
              <Route path="/tables/:sub/:slug" element={<Table />} />
              <Route path="/tables-new/:sub/:slug" element={<TableNew />} />
            </Route>

            <Route element={<PageInfoProvider />}>
              <Route path="/info" element={<PageInfo />} />
              <Route path="/info/:slug" element={<PageInfoUrl />} />
            </Route>
        </Route>
      </Routes>
    </ActiveCountryTagProvider>
    </HelmetProvider>

  )
}

export default App
